<template>
  <div class="produceAnalyse">
    <div class="content">

      <!-- <div class="Files-top">
        <div class="ic-left">
          <span>产能分析</span>
        </div>
        <div class="btns">
         
        </div>
      </div> -->
      

      <div class="search-input-btn" style="width:100%">
                  <el-scrollbar style="height:100%;width: 100%;">
                        <div class="my-search-i">
                          <div class="input-small ins mr-20">
                          <span>车间：</span>
                               <el-select multiple collapse-tags v-model='selectedArray' @change='changeSelect' @remove-tag='removeTag'
                                  placeholder='选择车间' style="width: 160px;">
                                  <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                                  <el-option v-for='(item, index) in options' :key='index' :label='item.capacityName'
                                    :value='item.id'></el-option>
                                </el-select>
                          </div>
                          <div class="input-small ins mr-20">
                          <span>时间：</span>
                                <el-select v-model="timeType" placeholder="请选择" style="width: 160px;" @change="timeType_fn">
                                      <el-option label="日" value="DAY"> </el-option>
                                      <el-option label="月" value="MON"> </el-option>
                                      <el-option label="年" value="YEAR"> </el-option>
                                    </el-select>
                          </div>
                          <div class="input-small ">
                          <span></span>
                                <el-date-picker class="picker" v-model="dateValue" type="date" placeholder="请选择日期" v-if="dateType == 'DAY'"
                              :picker-options="pickerOptions"></el-date-picker>
                            <el-date-picker class="picker" v-model="dateValue" type="month" placeholder="请选择月份" v-if="dateType == 'MON'"
                              :picker-options="pickerOptions"></el-date-picker>
                            <el-date-picker class="picker" v-model="dateValue" type="year" placeholder="请选择年份" v-if="dateType == 'YEAR'"
                              :picker-options="pickerOptions"></el-date-picker>
                          </div>
                            <el-button type="primary" size="mini" plain @click="getList" class="search-btn">查询</el-button>
                           <el-button type="primary" size="mini" @click="exportList" class="search-btn">导出</el-button>
                            </div>
          </el-scrollbar>

                          
                </div>




      <div class="content-chart">
        <vchart style="height: 380px" ref='vchart'></vchart>
      </div>

      <div class="content-table" style="margin-top:20px">
        <el-table :data="tableData" v-loading="loading" border style="width: 100%" :max-height="heights">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" width="180" label="名称"> </el-table-column>
          <el-table-column prop="type" label="类型" width="180"> </el-table-column>
          <el-table-column prop="unit" align="center" label="单位" width="90"> </el-table-column>
          <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
            align="center" :width="item.width"> </el-table-column>
        </el-table>
      </div>
    </div>
    <downloadTable ref="downloadTable"></downloadTable>
  </div>
</template>

<script>
  import {getMappingList,capacityFindReport} from "../../api/capacity";
  import * as echarts from "echarts";
  import vchart from '@/components/module/chart/vchart.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTableImg.vue'
  export default {
    components: {
      vchart,
      downloadTable
    },

    data () {
      return {
        heights: Math.round((document.getElementById('app').clientHeight) * 0.38),
        loading: false,
        //下拉框
        selectedArray: [],
        options: [],
        nowSelectArr: [],
        //时间
        timeType: "DAY",
        dateValue: new Date().getTime()-86400000,
        dateType: "DAY",
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now()-86400000;
          },

        },
        //图表
        middleData: {},
        //表格
        tableData: [],
        //类型
        tableType: ['产量','电量','能耗'],
        columns: [],
        dayData: [],
        monthData: [],
        yearData: [],

      };
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
    },

    mounted () {
      for(let i=1;i<=31;i++) {
        if(i<=24) {
          this.dayData.push(i>9? i+':00':'0'+i+':00')
        }
        if(i<=12) {
          this.columns.push({
            'name': `${i}时`
          })
          this.yearData.push(i+'月')
        }
        this.monthData.push(i+'号');
      }
      //初始化图表
      this.init()
      for(let i=1;i<13;i++) {

      }
      this.getSelectList()
    },

    watch: {
      unitId () {
        this.getSelectList()
      },


    },

    methods: {

      selectAll () {

        if(this.selectedArray.length<this.options.length) {
          this.selectedArray=[]
          this.options.map((item) => {
            this.selectedArray.push(item.id)
          })
          this.selectedArray.unshift('全选')
        } else {
          this.selectedArray=[]
        }
      },
      changeSelect (val) {
        if(!val.includes('全选')&&val.length===this.options.length) {
          this.selectedArray.unshift('全选')
        } else if(val.includes('全选')&&(val.length-1)<this.options.length) {
          this.selectedArray=this.selectedArray.filter((item) => {
            return item!=='全选'
          })

        }
        setTimeout(() => {
          var newArr=JSON.parse(JSON.stringify(this.selectedArray))
          // console.log("数组",newArr);
          this.nowSelectArr=newArr.filter(item => item!='全选')
          this.getList()
        },500)

      },
      removeTag (val) {
        if(val==='全选') {
          this.selectedArray=[]
        }
      },
      //时间类型变化
      timeType_fn (val) {
        this.dateType=val
        this.getList()
      },
      //初始化图表
      init () {
        var a=[]
        var b=[]
        for(let i=1;i<10;i++) {
          a.push(i)
          b.push({
            name: i,
            data: [10,20,30,40,50,60,40],
            smooth: true,
            type: "line"
          })
        }
        this.middleData=this.$refs.vchart.getDefaultOptions()
        this.middleData.xAxis={
          type: 'category',
          splitLine: {
            show: false,
            lineStyle: {
              width: .5,
              type: 'solid'
            }
          },
          data: this.monthData
        }
        this.middleData.yAxis={
          lineStyle: {
            show: false,
            width: 1,
            type: 'solid',
          }
        }
        this.middleData.grid={
          left: '3%',
          right: '4%',
          bottom: '14%',
          containLabel: true
        }
        this.middleData.legend={
          data: [],
          type: 'scroll',
          bottom: 0,
          icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 12, // 设置高度
          textStyle: {
            lineHeight: 56,
            fontSize: 14
          },
          itemGap: 50 // 设置间距
        },
          this.middleData.toolbox={
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "50",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },

              saveAsImage: {
                show: true,
                title: '下载图片'
              },
            },

          },

          this.middleData.tooltip={
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          }
        this.middleData.dataZoom=[
        ]
        this.middleData.series=[]
        var timerStr=this.date_format_fn(this.dateValue)
        this.middleData.title.text=timerStr.substr(1,10)

        this.$refs.vchart.setData(this.middleData,true)
        // this.getSelectList()
      },
      //获取下拉框列表
      getSelectList () {
        var id=this.unitId.id
        getMappingList({'unitId': id}).then(res => {
          if(res.code==200) {
            var data=res.data
            this.options=data.filter(item => item.status=='ENABLE')
            if(this.options.length!=0) {
              this.selectedArray.push(res.data[0].id)
              this.nowSelectArr.push(res.data[0].id)
              this.getList()
            }

          }
        })
      },
      //获取图表跟表格数据
      getList () {
        var str=''
        this.nowSelectArr.forEach(item => str+=','+item)
        var d={
          'dateType': this.timeType,
          'mappingId': str.substr(1),
          'requestTime': typeof this.dateValue=='number'? this.dateValue:this.dateValue.getTime(),
        }

        this.loading=true

        capacityFindReport(d).then(res => {
          if(res.code==200) {
            var data=res.data
            var legend=[]
            var series=[]
            var xAxis=[]
            this.columns=[]
            var ceTbale=[]
            var str=""
            var columnsArr=[];

            data.forEach((item,index) => {
              legend.push(`${item.mappingName}(kw·h/${item.unitName})`)
              series.push({
                name: `${item.mappingName}(kw·h/${item.unitName})`,
                data: [],
                smooth: true,
                type: "bar",
                barMaxWidth: "30"
              })
              this.tableType.forEach((v,i) => {
                ceTbale.push({
                  'name': i==1? item.mappingName:'',
                  'type': v,
                  'unit': this.unit_fn(v,item.unitName)

                })
              })
              item.valueFpromDay.forEach(t => {
                if(this.timeType=='YEAR') {
                  str=(t.searchTime).substring(5,7)
                  // str = (t.searchTime).substring(5,7) + '月'
                  columnsArr.push({
                    name: str,
                    key: str,
                    width: '90',
                    date: t.searchTime
                  })
                  xAxis.push(str)
                } else if(this.timeType=='MON') {
                  str=(t.searchTime).slice(-2)
                  // str = (t.searchTime).slice(-2) + '号'
                  columnsArr.push({
                    name: str,
                    key: str,
                    width: data[0].valueFpromDay.length>12? '112':'',
                    date: t.searchTime
                  })
                  xAxis.push(str)
                } else {
                  //  str = (t.searchTime).slice(-2) + '号'
                  str=(t.searchTime).slice(-2)
                  columnsArr=[{
                    name: str,
                    key: str,
                    width: "",
                    date: t.searchTime
                  }]
                  xAxis=[str]
                }
                // ceTbale[index * 3 ][str] = t.capacityValue
                // ceTbale[index * 3 + 1][str] = t.electricQuantity
                // ceTbale[index * 3 + 2][str] = t.energyConsumption
                // series[index].data.push(t.energyConsumption)
              })
            })

            let columnsObj={}
            let set=columnsArr.reduce((cur,next) => {
              columnsObj[next.key]? "":columnsObj[next.key]=true&&cur.push(next);
              return cur;
            },[])

            var xAxisRes=[...new Set(xAxis)]
            set.sort(function(a,b) {
              return a.key-b.key;
            })
            xAxisRes.sort(function(a,b) {
              return a-b;
            })
            set.forEach(item => item.name=item.key+'号')
            this.columns=set

            //再次遍历一次，排序一下图表数据
            var newArr=[]
            var newStr=""
            data.forEach((v,i) => {
              set.forEach(val => { //已经处理好的排序数组
                newArr=v.valueFpromDay.filter(item => item.searchTime==val.date)
                if(this.timeType=='YEAR') {
                  newStr=(val.date).substring(5,7)
                  // newStr = (val.date).substring(5,7) + '月'
                } else if(this.timeType=='MON') {
                  newStr=(val.date).slice(-2)
                  // newStr = (val.date).slice(-2) + '号'
                } else {
                  //  newStr = (val.date).slice(-2) + '号'
                  newStr=(val.date).slice(-2)
                }
                if(newArr.length==0) {
                  series[i].data.push(0)
                  ceTbale[i*3][newStr]=""
                  ceTbale[i*3+1][newStr]=""
                  ceTbale[i*3+2][newStr]=""
                } else {
                  series[i].data.push(newArr[0].energyConsumption)
                  ceTbale[i*3][newStr]=newArr[0].capacityValue
                  ceTbale[i*3+1][newStr]=newArr[0].electricQuantity
                  ceTbale[i*3+2][newStr]=newArr[0].energyConsumption
                }
              })
            })



            var timerStr=this.date_format_fn(this.dateValue)
            if(this.timeType=='DAY') {
              this.middleData.title.text=timerStr.substr(1,10)
            } else if(this.timeType=='MON') {
              this.middleData.title.text=timerStr.substr(1,7)
            } else {
              this.middleData.title.text=timerStr.substr(1,4)
            }
            this.middleData.xAxis.data=xAxisRes
            this.middleData.legend.data=legend
            this.middleData.series=series
            this.tableData=ceTbale
            this.$refs.vchart.setData(this.middleData,true)
            this.loading=false
          } else {
            this.loading=false
            res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查绑定的设备！！！')
          }
        })

      },
      //转换单位
      unit_fn (type,val) {
        if(type=='产量') {
          return val
        } else if(type=='电量') {
          return 'kw·h'
        } else {
          return `kw·h/${val}`
        }
      },
      //下载表格excel
      exportList () {
        let mycanvas=document.getElementsByTagName('canvas')[0]
        let image=mycanvas.toDataURL("image/png");
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        // var type =  this.typeOptions.filter(item => item.appTypeNo == this.energyType)
        var timeType=""
        if(this.timeType=='DAY') {
          timeType="日"
        } else if(this.timeType=='MONTH') {
          timeType="月"
        } else {
          timeType="年"
        }
        const tHeader=['周期',timeType,"查询时间",this.date_format_fn(this.dateValue)];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-产量分析+数据曲线','.content-table',image)
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },
    },
  };
</script>

<style lang="scss" scoped>
  .produceAnalyse {
    box-sizing: border-box;
    overflow: hidden;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
     padding: 2px 20px 20px 20px;
      box-sizing: border-box;

      /deep/.el-select .el-input__inner {
        width: 160px;
      }

      /deep/.search-input-btn .ins .el-input--suffix {
        width: 160px;
      }

      /deep/.search-input-btn .myinput .el-input {
        width: 1.6rem;
      }

      .content-top {
        position: relative;
        // margin: 10px 20px 20px 20px;
        margin-left: 20px;

        .btns {
          position: absolute;
          top: 50%;
          right: 0px;
          transform: translateY(-50%);
        }

        /deep/.el-input__inner {
          height: 32px;

        }

        /deep/.el-input__icon {
          line-height: 32px;
        }
      }



      .content-table {


        /deep/.el-table th {
          background-color: #F1F5FA;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
        }

        /deep/.el-table td {
          padding: 8px 0px;
          // border: 0px;
        }

        /deep/tr:nth-of-type(6n+4) {
          background-color: #F7FAFF;
        }

        /deep/tr:nth-of-type(6n+5) {
          background-color: #F7FAFF;
        }

        /deep/tr:nth-of-type(6n+6) {
          background-color: #F7FAFF;
        }

        /deep/tr td:nth-child(2) {
          border-bottom-color: transparent;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }
      }
    }
  }
</style>